import { render } from "./Sv012.vue?vue&type=template&id=36dda888&scoped=true"
import script from "./Sv012.vue?vue&type=script&lang=js"
export * from "./Sv012.vue?vue&type=script&lang=js"

import "./Sv012.vue?vue&type=style&index=0&id=36dda888&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-36dda888"]])

export default __exports__